var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CkEditorFormGroup',{attrs:{"name":"content","label":"Content","error":(_vm.errors.content || [])[0]},model:{value:(_vm.data.content),callback:function ($$v) {_vm.$set(_vm.data, "content", $$v)},expression:"data.content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }